import styled from 'styled-components'
import { media } from '../../config/settings/media'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
  margin: 1rem 0 1.5rem;

  ${media.md`
    gap: 1.35rem;
    margin: 0.75rem 0 1.75rem;
  `}
`

export const Form = styled.form``

export const ErrorText = styled.p`
  margin: 0;
  padding: 0.9rem 1.1rem;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.action.danger.bg}33;
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(220, 38, 38, 0.12)'
      : 'rgba(220, 38, 38, 0.06)'};
  color: ${({ theme }) => theme.colors.action.danger.bg};
  font-size: 0.875rem;
  font-weight: 500;
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 2.25rem 1.25rem;
  border-radius: 12px;
  border: 1px dashed ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) => theme.colors.background};
  text-align: center;

  strong {
    font-size: 0.9375rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.textPrimary};
  }

  span {
    font-size: 0.8125rem;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`

export const UtmCard = styled.article`
  position: relative;
  overflow: hidden;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) => theme.colors.background};
`

export const CardMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.65rem;

  ${media.sm`
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  `}
`

export const CardIdentity = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
  flex: 1;
`

export const CardPeriod = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.25;
  color: ${({ theme }) => theme.colors.textPrimary};
`

export const CardSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
  flex-shrink: 0;

  ${media.sm`
    align-items: flex-end;
    text-align: right;
  `}
`

export const CardValue = styled.div`
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.15;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-variant-numeric: tabular-nums;

  ${media.sm`
    font-size: 1.2rem;
  `}
`

export const YearGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const YearLabel = styled.h3`
  margin: 0;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const CardsWrapper = styled.div`
  display: grid;
  gap: 0.5rem;
  grid-template-columns: 1fr;
`
